import { documentDirectory } from '../../utils/fileSystemCompat'
import React, { useEffect, useState } from 'react'
import { Dimensions, StyleSheet, View, Platform, Text } from 'react-native'
import { Image } from 'expo-image'
import { File, Directory, Paths } from 'expo-file-system'

export const GamificationAnimatedBackground = ({ offset, parallaxImages }) => {
    const animatedImageStyle = {}

    return (
        <>
            <View style={[{ position: 'absolute', bottom: 0, zIndex: 0, width: '50%' }, animatedImageStyle]}>
                <Image
                    style={{
                        position: 'absolute',
                        width: 500,
                        top: -50,
                    }}
                    source={require('../../../assets/gamification/gami_finish.png')}
                />
                {parallaxImages
                    .sort((a, b) => b.index - a.index)
                    .map((item, index) => {
                        return <ParallaxImage key={item.name + index} item={item} />
                    })}
                <Image
                    style={{
                        position: 'absolute',
                        width: 500,
                        bottom: 0,
                    }}
                    source={require('../../../assets/gamification/gami_init.png')}
                />
            </View>
            <Text style={{ position: 'absolute', bottom: 200, backgroundColor: 'white', color: 'black', fontWeight: '700' }}>
                Este view es particular de la version web
            </Text>
        </>
    )
}

export const ParallaxImage = React.memo(({ item }: any) => {
    const isWeb = Platform.OS === 'web'
    const AnimatedImage = Image
    const [image, setImage] = useState(item.name)
    const style = StyleSheet.create({
        imageStyle: item.styles,
    })
    const searchImage = async (image: string) => {
        if (!image) {
            return { uri: '' } // fallback
        }

        const directoryUri = `${documentDirectory}unzipped/gamification/${image}`

        const fileInfo = new File(directoryUri)

        if (fileInfo.exists) {
            return { uri: fileInfo.uri }
        }

        return { uri: '' }
    }
    useEffect(() => {
        const fetchImage = async () => {
            const imageResult = await searchImage(item.name)
            setImage(imageResult)
        }

        fetchImage()
    }, [item])
    return <AnimatedImage style={[style.imageStyle]} source={image} contentFit={'contain'} /> // cachePolicy={'memory'}
})
